import React from 'react';

const DealsPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-base-content mb-2">Сделки</h1>
        <p className="text-base-content/70">
          Управление сделками и их содержимым
        </p>
      </div>
      
      <div className="max-w-md mx-auto">
        <div className="card bg-gradient-to-br from-info/5 to-info/10 border border-info/20">
          <div className="card-body text-center">
            <div className="w-16 h-16 mx-auto bg-info/20 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current text-info w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 className="text-base font-semibold text-base-content mb-2">В разработке</h3>
            <p className="text-base-content/70 mb-4">
              Страница управления сделками находится в разработке. 
              Скоро здесь появится полный функционал для работы с вашими сделками.
            </p>
            <div className="badge badge-info">Скоро</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealsPage;
